export const VANILLA_MUSICGEN_ID = 'p2ppjbkp2vqmw2'
export const SPLIT_STEMS_RUNPOD_ID = '75iqp64pqfm547'
